import React, { useState } from "react";
import AppText from "./AppText";
import { isValidVerificationCode } from "../utils";
import Input from "../../presentational/Input";
import QRCode from "../../presentational/QRCode/QRCode";
import Button from "../../presentational/Button";
import Links from "./Links";

interface AddTotpProps {
    isSubView?: boolean;
    serverError: string;
    isLoading: boolean;
    totpKey: string;
    totpQrCodeUri: string;
    enableTotp: (totpKey: string, code: string) => void;
    cancel: () => void;
}

const AddTotp: React.FC<AddTotpProps> = ({ isSubView, serverError, isLoading, totpKey, totpQrCodeUri, enableTotp, cancel }) => {
    const [verificationCode, setVerificationCode] = useState("");

    const onSetVerificationCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        const code = event?.target?.value?.trim();
        setVerificationCode(code);
        if (isValidVerificationCode(code)) {
            enableTotp(totpKey!, code);
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        enableTotp(totpKey!, verificationCode);
        return false;
    };

    const content = (
        <>
            <p>
                <AppText textKey="totp-instructions-1" />
            </p>
            <p>
                <AppText textKey="totp-instructions-2" />
            </p>
            <p>{totpQrCodeUri && <QRCode value={totpQrCodeUri} size={150} />}</p>
            <p>
                <AppText textKey="totp-instructions-code" /> <strong>{totpKey}</strong>
            </p>
            <p>
                <AppText textKey="totp-instructions-3" />
            </p>
            <div className="field-group">
                <label className="login-field" htmlFor="totpVerificationCode">
                    <AppText textKey="totp-code-label" />
                </label>
                <Input
                    autoComplete="one-time-code"
                    className="autofocus"
                    disabled={isLoading}
                    onChange={onSetVerificationCode}
                    id="totpVerificationCode"
                    value={verificationCode}
                    placeholder="123456"
                    fullWidth={true}
                    autoFocus={true}
                    htmlAttributes={{
                        maxLength: 6,
                        pattern: "[0-9]{6}",
                        spellCheck: false,
                        autoCorrect: "off",
                        autoCapitalize: "none",
                    }}
                />
            </div>
            <Button
                onClick={handleSubmit}
                intent="primary"
                disabled={!isValidVerificationCode(verificationCode) || isLoading}
                type="submit"
            >
                <AppText textKey="totp-enable-label" />
            </Button>
        </>
    );

    return isSubView ? (
        content
    ) : (
        <main>
            <div className="form-wrapper">
                <form className="form" onSubmit={handleSubmit}>
                    {serverError && <p className="server-error">{serverError}</p>}
                    <div className="form-header">
                        <h2>
                            <AppText textKey="totp-title" />
                        </h2>
                        <p>
                            <AppText textKey="totp-info" />
                        </p>
                    </div>
                    {content}
                    <Button onClick={cancel}>
                      <AppText textKey="totp-cancel-label" />
                    </Button>
                </form>
                <Links />
            </div>
        </main>
    );
};

export default AddTotp;
